/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

/**
 * @readonly
 * @enum {string};
 */
gbc.constants.widgetCssClasses = {
  // TODO : Change the following classes to gbc_checked & gbc_unchecked.
  // TODO : And make a DOC ticket to notify our customers of this change as it might break the custo
  checked: "checked",
  current: "current",
  close: "close",
  unchecked: "unchecked",
  collapsed: "collapsed",
  isCurrentColumn: "gbc_isCurrentColumn",
  isCurrentRow: "gbc_isCurrentRow",
  isCurrentCell: "gbc_isCurrentCell",
  isFocused: "gbc_Focus",
  isHighlighted: "gbc_isHighlighted",
  isInMatrix: "gbc_isInMatrix",
  isInScrollGrid: "gbc_isInScrollGrid",
  isInTable: "gbc_isInTable",
  isSelected: "gbc_isSelected",
  isStandalone: "gbc_isStandalone",
  chromeItem: "gbc_chromeItem",
  windowItem: "gbc_windowItem"
};
